import { POS_SALES_SCOPES } from '../constants/posConst';
import '../css/Pos.css';
import '../css/PosSubscription.css';

/**
 * "My sales" or "Overall" — the Sales report's only choice of whose takings it
 * covers, for staff who are not the store's admin.
 *
 * A store admin gets the full per-person staff filter (PosStaffFilter)
 * instead; this is what everyone else sees in its place.
 *
 * @param {object} props
 * @param {string} props.value - a key from POS_SALES_SCOPES
 * @param {(value: string) => void} props.onChange
 * @returns {JSX.Element}
 */
function PosSalesScopeToggle({ value, onChange }) {
  return (
    <div className="ps-scope" role="radiogroup" aria-label="Whose sales to show">
      {POS_SALES_SCOPES.map((option) => (
        <button
          key={option.key}
          type="button"
          role="radio"
          aria-checked={value === option.key}
          className={`ps-scope-btn${value === option.key ? ' active' : ''}`}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default PosSalesScopeToggle;
